import { App } from "vue";
import { Router } from "vue-router";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

interface SentryErorrHandler {
  title: string;
  context: Array<{ title: string; content: any }>;
}

export default function install(app: App<Element>, router: Router) {
  if (!import.meta.env.VITE_DEPLOY) return;

  Sentry.init({
    app,
    dsn:
      "https://11c90ea4dbe8412e86eb17601129e281@o1064902.ingest.sentry.io/6349210",
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [],
      }),
    ],
    environment: import.meta.env.VITE_ENV,
    release: `dpost-portal@${import.meta.env.VITE_ENV}:${__APP_VERSION__}`,
    tracesSampleRate: 1,
    attachProps: true,
    logErrors: true,
    tracingOptions: {
      trackComponents: true,
    },
  });
}

export const sentryErrorHandler = (data: SentryErorrHandler) => {
  Sentry.withScope((scope) => {
    // CustomContext
    Array.isArray(data.context) &&
      data.context.forEach((item) => {
        scope.setContext(item.title, item.content);
      });

    Sentry.captureMessage(data.title ? data.title : "CustomError");
  });
};
